import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props} data-testid={`notification-${id}`}>
            <div className="grid gap-1">
              {title && <ToastTitle data-testid={`notification-title-${id}`}>{title}</ToastTitle>}
              {description && (
                <ToastDescription data-testid={`notification-description-${id}`}>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose aria-label="Zatvori obavijest" data-testid={`notification-close-${id}`} />
          </Toast>
        );
      })}
      <ToastViewport data-testid="notification-viewport" />
    </ToastProvider>
  );
}
